import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertColor, Button, Snackbar, IconButton, useTheme } from '@mui/material';
import React from 'react';

export interface EnhancedSnackbarProps {
    open: boolean;
    autoHideDuration?: number;
    severity: AlertColor;
    message: string;
    action?: string;
    forceColor?: string;
    onAction?: () => void;
    onClose?: () => void;
}

export interface Snackbar {
  severity: "info" | "error" | "warning" | "success";
  message: "";
}

const ActionButton = ({
    onAction,
    action,
    onClose,
}: {
    onAction?: () => void;
    action?: string;
    onClose?: () => void;
}) => (
    <>
        <Button color="secondary" size="small" onClick={onAction}>
            {action}
        </Button>
        <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon fontSize="small"/>
        </IconButton>
    </>
);

const EnhancedSnackbar = (props: EnhancedSnackbarProps) => {
    const {open, autoHideDuration, severity, message, action, forceColor, onAction, onClose} = props;

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration || 6000}
            onClose={onClose}
            action={action && <ActionButton action={action} onClose={onClose} onAction={onAction}/>}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >

            <Alert variant="filled" onClose={onClose} severity={severity} sx={{width: '100%', 
                backgroundColor: forceColor }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export interface SnackbarConfig {
    open: boolean;
    severity: AlertColor;
    message: string;
}

export default EnhancedSnackbar;
